import { getLocale } from "../i18n";
export function dateFormat(date, config = {}) {
    date = parseDate(date);
    return date ? date.toLocaleDateString(getLocale(), config) : null;
}
export function parseDate(date) {
    if (!date) {
        return null;
    }
    if (typeof date === "string") {
        date = new Date(date);
    }
    return isValidDate(date) ? date : null;
}
export function isValidDate(date) {
    return !isNaN(date.getTime());
}
